import * as yup from "yup";
import { serializers, deserializers } from "../utils";

const pickShape = yup.array().of(
  yup.object().shape({
    from: yup.number().defined(),
    to: yup.number().defined(),
    price: yup.number().defined(),
  })
);

const tierShape = yup.array().of(
  yup.object().shape({
    from: yup.number().defined(),
    to: yup.number().defined(),
    picks: pickShape,
  })
);

const weightShape = yup.array().of(
  yup.object().shape({
    from: yup.number().defined(),
    to: yup.number().defined(),
    label: yup.string().defined(),
    tiers: tierShape,
  })
);

const pickFeeDeserializedShape = yup
  .object()
  .shape({
    weights: weightShape,
    description: yup.string(),
  })
  .defined();

export const serializedFormSchema = yup
  .object()
  .shape({
    postageFee: yup
      .object()
      .shape({
        units: yup.string().oneOf(["percentage", "fixed"]),
        number: yup.number().defined(),
      })
      .transform((value, originValue) => {
        if (value.units === "fixed") {
          return {
            ...value,
            number: serializers.cents(value.number, originValue.number),
          };
        }

        return value;
      })
      .defined(),
    pickFee: pickFeeDeserializedShape,
  })
  .defined();

export const deserializedFormSchema = yup
  .object()
  .shape({
    postageFee: yup
      .object()
      .shape({
        units: yup.string().oneOf(["percentage", "fixed"]),
        number: yup.number().defined(),
      })
      .transform((value, originValue) => {
        if (value.units === "fixed") {
          return {
            ...value,
            number: deserializers.cents(value.number, originValue.number),
          };
        }

        return value;
      })
      .default(undefined),
    pickFee: pickFeeDeserializedShape,
  })
  .defined();
